import { Component, Input } from "@angular/core";
import { Grid } from "./s25.virtual.grid.component";

@Component({
    template: "",
    standalone: false,
})
export class S25VirtualGridAbstractItem<ItemData extends Grid.CustomData> {
    @Input() item: Grid.Item<ItemData>;
    @Input() dragging: Grid.Dragging<ItemData>; // Being dragged by user
    @Input() moving: boolean; // Being moved automatically
}
